// Class: starling.filters.ColorMatrixFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_filters_ColorMatrixEffect() {return require("./../../starling/filters/ColorMatrixEffect");}
function starling_utils_Color() {return require("./../../starling/utils/Color");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}

// Constructor

var ColorMatrixFilter = function(matrix) {
	(starling_filters_FragmentFilter().default).call(this);
	if(matrix != null) {
		this.get_colorEffect().set_matrix(matrix);
	}
}

// Meta

ColorMatrixFilter.__name__ = ["starling","filters","ColorMatrixFilter"];
ColorMatrixFilter.__super__ = (starling_filters_FragmentFilter().default);
ColorMatrixFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	createEffect: function() {
		return new (starling_filters_ColorMatrixEffect().default)();
	},
	invert: function() {
		this.concatValues(-1,0,0,0,255,0,-1,0,0,255,0,0,-1,0,255,0,0,0,1,0);
	},
	adjustSaturation: function(sat) {
		++sat;
		var invSat = 1 - sat;
		var invLumR = invSat * 0.299;
		var invLumG = invSat * 0.587;
		var invLumB = invSat * 0.114;
		this.concatValues(invLumR + sat,invLumG,invLumB,0,0,invLumR,invLumG + sat,invLumB,0,0,invLumR,invLumG,invLumB + sat,0,0,0,0,0,1,0);
	},
	adjustContrast: function(value) {
		var s = value + 1;
		var o = 128 * (1 - s);
		this.concatValues(s,0,0,0,o,0,s,0,0,o,0,0,s,0,o,0,0,0,1,0);
	},
	adjustBrightness: function(value) {
		value *= 255;
		this.concatValues(1,0,0,0,value,0,1,0,0,value,0,0,1,0,value,0,0,0,1,0);
	},
	adjustHue: function(value) {
		value *= Math.PI;
		var cos = Math.cos(value);
		var sin = Math.sin(value);
		this.concatValues(0.299 + cos * 0.701000000000000068 + sin * -0.299,0.587 + cos * -0.587 + sin * -0.587,0.114 + cos * -0.114 + sin * 0.886,0,0,0.299 + cos * -0.299 + sin * 0.143,0.587 + cos * 0.413000000000000034 + sin * 0.14,0.114 + cos * -0.114 + sin * -0.283,0,0,0.299 + cos * -0.299 + sin * -0.701000000000000068,0.587 + cos * -0.587 + sin * 0.587,0.114 + cos * 0.886 + sin * 0.114,0,0,0,0,0,1,0);
	},
	tint: function(color,amount) {
		if(amount == null) {
			amount = 1.0;
		}
		var r = (starling_utils_Color().default).getRed(color) / 255.0;
		var g = (starling_utils_Color().default).getGreen(color) / 255.0;
		var b = (starling_utils_Color().default).getBlue(color) / 255.0;
		var q = 1 - amount;
		var rA = amount * r;
		var gA = amount * g;
		var bA = amount * b;
		this.concatValues(q + rA * 0.299,rA * 0.587,rA * 0.114,0,0,gA * 0.299,q + gA * 0.587,gA * 0.114,0,0,bA * 0.299,bA * 0.587,q + bA * 0.114,0,0,0,0,0,1,0);
	},
	reset: function() {
		this.set_matrix(null);
	},
	concat: function(matrix) {
		this.get_colorEffect().concat(matrix);
		this.setRequiresRedraw();
	},
	concatValues: function(m0,m1,m2,m3,m4,m5,m6,m7,m8,m9,m10,m11,m12,m13,m14,m15,m16,m17,m18,m19) {
		ColorMatrixFilter.sMatrix.length = 0;
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,0,m0);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,1,m1);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,2,m2);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,3,m3);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,4,m4);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,5,m5);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,6,m6);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,7,m7);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,8,m8);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,9,m9);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,10,m10);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,11,m11);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,12,m12);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,13,m13);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,14,m14);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,15,m15);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,16,m16);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,17,m17);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,18,m18);
		(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixFilter.sMatrix,19,m19);
		this.concat(ColorMatrixFilter.sMatrix);
	},
	get_matrix: function() {
		return this.get_colorEffect().get_matrix();
	},
	set_matrix: function(value) {
		this.get_colorEffect().set_matrix(value);
		this.setRequiresRedraw();
		return value;
	},
	get_colorEffect: function() {
		return this.get_effect();
	}
});
ColorMatrixFilter.prototype.__class__ = ColorMatrixFilter.prototype.constructor = $hxClasses["starling.filters.ColorMatrixFilter"] = ColorMatrixFilter;

// Init

Object.defineProperties(ColorMatrixFilter.prototype,{ "matrix" : { get : function () { return this.get_matrix (); }, set : function (v) { return this.set_matrix (v); }}, "colorEffect" : { get : function () { return this.get_colorEffect (); }}});

// Statics


ColorMatrixFilter.LUMA_R = 0.299
ColorMatrixFilter.LUMA_G = 0.587
ColorMatrixFilter.LUMA_B = 0.114
ColorMatrixFilter.sMatrix = (openfl__$Vector_Vector_$Impl_$().default)._new()

// Export

exports.default = ColorMatrixFilter;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/ColorMatrixFilter.js
// module id = 318
// module chunks = 0